<template>
    <div
        ref="modal"
        class="modal default-modal"
        data-backdrop="static"
        tabindex="-1"
        role="dialog"
        aria-labelledby="uploadModal-title"
        aria-modal="true"
        hidden
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button class="close" data-dismiss="modal" aria-label="Close Modal" @click.prevent="closeAllModal()">
                        <i class="fa-solid fa-xmark" aria-hidden="true" />
                    </button>

                    <h2 id="uploadModal-title" class="modal-title">Upload Teachers</h2>
                </div>
                <div class="modal-body textAlignCenter">
                    <div class="flex align-items marginBottom20">
                        <p class="marginRight8">
                            All teacher details are
                            <span class="important">compulsory</span>
                        </p>

                        <button
                            class="btn btn-primary margin0 flexInherit"
                            aria-label="Download CSV Template"
                            @click.prevent="download('intedashboard-teacher-upload-template.csv')"
                        >
                            <i class="fa fa-download marginRight8" aria-hidden="true"></i>
                            CSV Template
                        </button>
                    </div>

                    <div class="creation">
                        <div class="uploadDiv">
                            <div>
                                <div>
                                    <div>
                                        <i class="fas fa-file-upload" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <button class="btn btn-primary" @click.prevent="openBulkUpload">Upload Here</button>
                            </div>
                        </div>
                    </div>

                    <div v-if="errorShow" class="alert alert-danger marginTop10" role="alert">
                        <i class="fas fa-exclamation-triangle marginRight8" aria-hidden="true"></i>
                        <p class="paddingTop5" v-dompurify-html="upload_form.errors.get('data')" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-outline-default" data-dismiss="modal" @click.prevent="closeModal()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, nextTick, getCurrentInstance } from 'vue';
import KrForm from '../../../../components/forms/form';
import * as filestack from 'filestack-js';
import { useDownload } from '@/composables/helpers/useDownload.ts';

const modal = ref(null);
const { proxy } = getCurrentInstance();
const { download } = useDownload();

const errorShow = ref(false);

const upload_form = new KrForm({
    fields: {
        data: '',
    },
    props: {},
    urls: {
        post: 'questions/store-uploaded',
    },
});

const upload = () => {
    nextTick(() => {
        $(modal.value).modal('show');
    });
};

const closeModal = () => {
    nextTick(() => {
        $(modal.value).modal('hide');
    });
};

const openBulkUpload = () => {
    var client = filestack.init(process.env.VUE_APP_FILESTACK_API_KEY);
    client
        .picker({
            accept: ['.csv'],
            maxFiles: 1,
            minFiles: 1,
            uploadInBackground: false,
            onFileUploadFinished: function (file) {
                $('#loading').removeClass('hide').addClass('show');
                upload_form.model.data = file;
                let url = 'teachers/store-uploaded';
                proxy.$papa.parse(file.url, {
                    download: true,
                    complete: function (results, file) {
                        if (results.errors.length == 0) {
                            upload_form.post(url).then(function (response) {
                                if (!response.krFormError) {
                                    proxy.$refs['teachers_listing'].debounced_search(true);
                                } else {
                                    if (!upload_form.errors.has('data')) {
                                        upload_form.errors.append('data', ['Malformed CSV. Please recheck.']);
                                    }
                                    // $('#uploadErrorTeachersModal').modal('show');
                                    errorShow.value = true;
                                }
                            });
                        } else {
                            upload_form.errors.append('data', ['Malformed CSV. Please recheck.']);
                            // $('#uploadErrorTeachersModal').modal('show');
                            errorShow.value = true;
                        }
                        $('#loading').removeClass('show').addClass('hide');
                        $('#uploadTeachersModal').modal('hide');
                    },
                });
            },
        })
        .open();
};

defineExpose({ upload });
</script>
